import React, { useState, useEffect } from 'react'
import swal from 'sweetalert';
import '../../material.css'
import { TimePickerComponent } from '@syncfusion/ej2-react-calendars'
import Select from 'react-select';
import axios from 'axios';

export default function AddPricing(props) {
    //const [timein, settimein] = useState("");
    //const [timeout, settimeout] = useState("");
//    const [items, setitems] = useState({ Shift_ID: "", daystype: "", mon: "", tue: "", wed: "", thur: "", fri: "", sat: "", sun: "", hol: "", UnitId: "", Amount: "", company_id: props.companyid })
    const [items, setitems] = useState({ Shift_ID: "", mon: "", tue: "", wed: "", thur: "", fri: "", sat: "", sun: "", hol: "", UnitId: "", Amount: "", company_id: props.companyid })
  
    //const [typevalue, settypevalue] = useState()
    const [addunit, setunit] = useState([])
    const [addshift, setshift] = useState([])
    const [unitvalue, setunitvalue] = useState()
    const [shiftvalue, setshiftvalue] = useState()
  
  //  const [daystypevalue, setdaystypevalue] = useState()
    //const [daystype, setdaystype] = useState([
    //    { label: "Weekdays", value: "1" },
    //    { label: "Weekends", value: "2" }
    //])
    useEffect(() => {
        fetchUnitdata()
        fetchShiftdata()
    }, []);

    async function fetchUnitdata() {
        const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnits?companyid=" + props.companyid;
        let Unitdata = await axios.get(Uniturl);
        var units = [];
        Unitdata.data.map((u) => {
            units.push({ value: u.unitId, label: u.unitName });
        })
        setunit(units);
    }
    async function fetchShiftdata() {
        const Shifturl = process.env.REACT_APP_APIURL + "Shift/GetPshifts?companyid=" + props.companyid;
        let Shiftdata = await axios.get(Shifturl);
        var shifts = [];
        Shiftdata.data.map((u) => {
            shifts.push({ value: u.shiftId, label: u.shiftName });
        })
        setshift(shifts);
    }
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
       
        if (name == "mon" || name == "tue" || name == "wed" || name == "thur" || name == "fri" || name == "sat" || name == "sun" || name == "hol") {
            if (e.target.checked) {

                setitems({ ...items, [name]: value })
            }
            else {
                setitems({ ...items, [name]: "" })
            }

        }
        else {
            setitems({ ...items, [name]: value })
        }
        
    }
   
    const refresh = () => {
 //       setitems({ ...items, Shift_ID: "", Amount: "", daystype: "", mon: "", tue: "", wed: "", thur: "", fri: "", sat: "", sun: "", hol: "", UnitId: "", company_id: props.companyid });
        setitems({ ...items, Shift_ID: "", Amount: "", mon: "", tue: "", wed: "", thur: "", fri: "", sat: "", sun: "", hol: "", UnitId: "", company_id: props.companyid });
      
        setunitvalue(null)
        setshiftvalue(null)
         // setdaystypevalue(null)
    }
    const savemethod = async (data) => {
      
        const url = process.env.REACT_APP_APIURL + "Pricing/AddPricing";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            debugger;
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    icon: "success"
                })
                refresh();

            }
            else {
                swal({
                    title: "Price is already present",
                    icon: "error"
                })
                refresh();
            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const submitButton = e.target.querySelector('button[type="submit"]');
        submitButton.disabled = true;
        submitButton.innerHTML = '<section><span class="loader-5"></span></section>';
      
        try {
          if (items.Shift_ID === "") {
            swal({
              title: "Shift Required!",
              icon: "error"
            });
            // Enable the submit button
            submitButton.disabled = false;
            // Reset the button text
            submitButton.innerHTML = "Submit";
            return;
          }
      
          if (items.UnitId === "") {
            swal({
              title: "Unit Required!",
              icon: "error"
            });
            // Enable the submit button
            submitButton.disabled = false;
            // Reset the button text
            submitButton.innerHTML = "Submit";
            return;
          }
      
          // Rest of your validations...
      
          await savemethod(items);
          // Reset the form
          // ...
      
          // Show success message
          swal({
            title: "Form submitted successfully!",
            icon: "success"
          });
        } catch (error) {
          // Show error message
          swal({
            title: "An error occurred!",
            text: error.message,
            icon: "error"
          });
        } finally {
          // Enable the submit button
          submitButton.disabled = false;
          // Reset the button text
          submitButton.innerHTML = "Submit";
        }
      };
      
    return (
        <div className="row">
            <div className="col-12 col-lg-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-2 mt-5 text-center mx-auto">Add Price</h3>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row flex-column align-items-center">
                                <div className="mb-3 col-sm-6 viz">
                                    <label htmlFor="unit_name" className="form-label">Shifts</label>
                                    <Select name="shift" autoComplete="off" value={shiftvalue} options={addshift} onChange={(e) => { setshiftvalue(e); setitems({ ...items, Shift_ID: e.value }) }} />
                                </div>
                                <div className="mb-3 col-sm-6 viz">
                                    <label htmlFor="unit_name" className="form-label">Unit</label>
                                    <Select name="unit" autoComplete="off" value={unitvalue} options={addunit} onChange={(e) => { setunitvalue(e); setitems({ ...items, UnitId: e.value }) }} />
                                </div>
                                <div className="mb-3 col-6">
                                    <label htmlFor="amount_name" className="form-label">Amount</label>
                                    <input type="text" className="form-control" name="Amount" value={items.Amount} onChange={handleInput} required />
                                </div>
                               
                                <div className="mb-3 col-sm-6">
                                    <label htmlFor="timepicker2">Day</label>
                                   {/* <Select value={daystypevalue} options={daystype} onChange={(e) => { setdaystypevalue(e); setitems({ ...items, daystype: e.value }) }} />*/}
                                    <div className="checkbox-group" id="checkboxes">
                                        <ul>
                                            <li>
                                                <input type="checkbox" id="mon" name="mon" value = "mon" onChange={handleInput} />
                                                <label htmlFor="mon">MON</label>
                                            </li>
                                            <li>
                                                <input type="checkbox" id="tue" name = "tue" value="tue" onChange={handleInput}/>
                                                <label htmlFor="tue">TUE</label>
                                            </li>
                                            <li>
                                                <input type="checkbox" id="wed" name = "wed" value="wed" onChange={handleInput}/>
                                                <label htmlFor="wed">WED</label>
                                            </li>
                                            <li>
                                                <input type="checkbox" id="thur" name = "thur" value="thur" onChange={handleInput}/>
                                                <label htmlFor="thur">THUR</label>
                                            </li>
                                            <li>
                                                <input type="checkbox" id="fri" name = "fri" value="fri" onChange={handleInput}/>
                                                <label htmlFor="fri">FRI</label>
                                            </li>
                                            <li>
                                                <input type="checkbox" id="sat" name = "sat" value="sat" onChange={handleInput}/>
                                                <label htmlFor="sat">SAT</label>
                                            </li>
                                            <li>
                                                <input type="checkbox" id="sun" name = "sun" value="sun" onChange={handleInput}/>
                                                <label htmlFor="sun">SUN</label>
                                            </li>
                                            <li>
                                                <input type="checkbox" id="hol" name="hol" value="hol" onChange={handleInput}/>
                                                <label htmlFor="hol">HOLIDAY</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div>
                                    <button type="submit" className="d-flex mx-auto btn btn-primary">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}